import React, { useEffect, useState } from 'react';
import utils from 'utils';
import { UmbracoStep } from 'components/Umbraco/UmbracoContext';
import { AutoComplete, CheckValidInputs, Row, Label, Tooltip, Line, MainCond, NumberField, StepBody, StepFooter, TextField, useInput } from 'meitav-uikit';
import { postData, setDataLayer } from '../../../../../utils/Functions';
import "./step31.scss";
import { isMobile } from 'react-device-detect';
import Footer from 'components/Footer';
import { Parser } from 'html-to-react';

const { UmbracoUtills, rest } = utils;

export default function Step31({
  resource,
  model,
  setModel,
  setStep,
  nextText,
  step,
  dataList,
  setDataList,
  resourceError,
  disable
}) {
  const resourceStep = UmbracoStep(resource, "SecondSub1Step");
  const p = new Parser();

  const [agentList, setAgentList] = useState(dataList.agent|| []);
  const [banks, setBanks] = useState(dataList.banks || []);
  const [branches, setBranches] = useState(dataList.branches || []);
  const [branchesFilter, setBranchesFilter] = useState([]);

  const myCond = {
    agent: {
      msg: UmbracoUtills.getValueByKey(resourceStep, "agentCodeError"),
      cond: (value) => (value ) && (!dataList?.agent?.find(x => x.AgentCode === value)),
    },
  }


  const [bankChange, setBankChange] = useState(false);
  const bank = useInput(UmbracoUtills.getValueByKey(resourceStep, 'bank'), null, [MainCond.empty]);
  const branch = useInput(UmbracoUtills.getValueByKey(resourceStep, 'snif'), null, [MainCond.empty]);
  const accountName = useInput(UmbracoUtills.getValueByKey(resourceStep, 'accountFullName'), model.paymentDetails?.depositBankAccountFullName, [MainCond.empty, MainCond.onlyHebrew]);
  const accountNum = useInput(UmbracoUtills.getValueByKey(resourceStep, 'accountNum'), model.paymentDetails?.depositBankAccountNum, [MainCond.empty, MainCond.onlyDigits]);
  const agentCode = useInput(UmbracoUtills.getValueByKey(resourceStep, 'agentCode'), model.paymentDetails?.agentCode, [myCond.agent]);
  const [depositSum, setDepositSum] = useState("");

  useEffect(() => {
    //getAgentsList();
    getPaymentsDetails();
    getDepositSumByProcessId();
  }, []);
  const getDepositSumByProcessId = async () => {
    await rest
      .get(`/api/Manager/GetDepositSumByProcessId`, {

      })
      .then((res) => {
        setDepositSum(res?.data);
      });
  };
  useEffect(() => {
    agentCode.setConds([]);
    if (agentCode.value) {
      agentCode.setConds([myCond.agent]);
    }
  }, [agentCode.value]);
  const getPaymentsDetails = async () => {

    if (banks.length == 0) {
      const res = await rest.get(`/api/general/GetBankList`);
      const res2 = await rest.get(`/api/general/GetBranchesList`);
      const res3 = await rest.get(`/api/Manager/getAgents`);

      setBanks(res?.data);
      setBranches(res2?.data);
      setAgentList(res3?.data);

      let tmpList = dataList;
      tmpList.banks = res?.data;
      tmpList.branches = res2?.data;
      tmpList.agent = res3?.data;

      setDataList(tmpList);
      localStorage.setItem('dataList', JSON.stringify(tmpList));
    }
  };
  useEffect(() => {
    if (banks.length) {
      if (model.paymentDetails.depositBankNum) {
        bank.setValue(banks.find(
          x => x.BankID === model.paymentDetails.depositBankNum,
        ));
      }
    }
  }, [banks]);

  useEffect(() => {
    if (branches.length) {
      if (model.paymentDetails.depositBankSnif) {
        branch.setValue(branches.find(
          x => x.BankId === model.paymentDetails.depositBankNum && x.BranchNum === model.paymentDetails.depositBankSnif,
        ));
      }
    }
  }, [branches]);

  useEffect(() => {

    if (bank.value.BankID && model.paymentDetails.depositBankNum != bank.value.BankID) {
      setBankChange(true);
      branch.setValue(null);
    }

    if (bankChange) {
      branch.setValue(null);
    }

    if (bank.value === null) {
      setBranchesFilter([]);
    } else if (branches) {
      const newList = branches.filter(x => x.BankId === bank.value.BankID);
      setBranchesFilter(newList);
    }

  }, [bank.value]);
  const handleNext = async () => {
    let tmpStep = bank.value.IsAllowInternalHandleManager ? 32 : 34;
    if (disable) {
      setStep(tmpStep);
      return;
    }
    if(!(model.utm_source || localStorage.getItem("utm_source")))
    {
      if (!CheckValidInputs([bank, branch, accountNum, accountName,agentCode])) {
        return;
      }
    }
    else {
      if (!CheckValidInputs([bank, branch, accountNum, accountName])) {
        return;
      }
    }

    setDataLayer("PM - bank account", window.location.pathname, "פרטי בנק", "המשך מוצלח של שלב פרטי בנק");

    let tmpModel = model;
    tmpModel.paymentDetails.depositBankNum = bank.value.BankID;
    tmpModel.paymentDetails.depositBankSnif = branch.value.BranchNum;
    tmpModel.paymentDetails.depositBankAccountNum = accountNum.value;
    tmpModel.paymentDetails.depositBankAccountFullName = accountName.value;
    tmpModel.paymentDetails.agentCode = agentCode.value;
    tmpModel.paymentDetails.depositSum = depositSum;
    tmpModel.paymentDetails.isBigBank = bank.value.IsAllowInternalHandleManager;
    tmpModel.paymentDetails.bankSiteURL = bank.value.bankSiteURL;
    tmpModel.currentStepID = 31;

    if(!bank.value.IsAllowInternalHandleManager && tmpModel.paymentDetails?.depositTypeId == 2) {
      tmpModel.paymentDetails.depositTypeId = 1;
    }

    tmpModel.stepID = tmpStep;
    postData(tmpModel, setStep);
  };

  const handlePrev = async () => {
    setDataLayer("PM - Levels", "/JoinPersonalDetails", "חזור לשלב הקודם", "חזרה - " + step);

    let tmpModel = model;
    if (bank.value) tmpModel.paymentDetails.depositBankNum = bank.value.BankID;
    if (branch.value) tmpModel.paymentDetails.depositBankSnif = branch.value.BranchNum;
    tmpModel.paymentDetails.depositSum = depositSum;
    tmpModel.paymentDetails.depositBankAccountNum = accountNum.value;
    tmpModel.paymentDetails.depositBankAccountFullName = accountName.value;
    if (bank.value) {
      tmpModel.paymentDetails.isBigBank = bank.value.IsAllowInternalHandleManager;
      tmpModel.paymentDetails.bankSiteURL = bank.value.bankSiteURL;

    }
    tmpModel.paymentDetails.agentCode = agentCode.value;

    setModel(tmpModel);
    if (tmpModel.mainUser?.asInvestPartner && model.mainUser?.commonBankAccount)
      setStep(23);
    else
      setStep(22);
  };

  return (
    <div className='step31'>
      <StepBody>
        <Line className="line">
          <AutoComplete id="bank" disable={disable}{...bank} options={banks} withValue={true} optionValue="BankID" optionText="BankName" />
          <AutoComplete id="branch" disable={disable} {...branch} options={branchesFilter} withValue={true} optionValue="BranchNum" optionText="BranchName" />
        </Line>
        <Line className=" line">
          <Row type='shrink'>
            <NumberField id="accountNum" disable={disable}{...accountNum} tooltipText={p.parse(UmbracoUtills.getValueByKey(resourceStep, 'tooltipAccountNum')) || ""} />
            <Label className='emptyLable' text=""></Label>
          </Row>
          <Row type='shrink'>
            <TextField id="accountName" disable={disable} {...accountName} tooltipText={p.parse(UmbracoUtills.getValueByKey(resourceStep, 'tooltipAccountFullName')) || ""} />
            <Label text={UmbracoUtills.getValueByKey(resourceStep, 'accountFullNameText')}></Label>
          </Row>
        </Line>
     { !(model.utm_source || localStorage.getItem("utm_source"))  ?
  <TextField className='agentCode' id="agentCode" disable={disable} {...agentCode} tooltipText={p.parse(UmbracoUtills.getValueByKey(resourceStep, 'tooltipAgentCode')) || ""} />:null}
      </StepBody>
      <StepFooter nextText={nextText}
        handleNext={handleNext} handlePrev={handlePrev} />
      <Footer text={p.parse(UmbracoUtills.getValueByKey(
        resourceStep,
        "mainText"
      ))}></Footer>
    </div>
  );
}
